import { useState, useContext, useEffect, useRef, useCallback } from 'react';

import { Button, Card, Form, Row, Col } from 'react-bootstrap';
import { format } from 'date-fns';

import { checkRequired } from 'utils/validationUtils';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useRestApi } from 'context/RestApiContext';
import { useMaster } from 'context/MasterContext';
import { getAge, getAgeCategory } from 'utils/ageUtils';
import { MessageModal } from 'components/modal/MessageModal';
import TextComponent from 'components/Input/TextComponent';
import SelectComponent from 'components/Input/SelectComponent';
import { getAddress } from 'utils/addresUtils';
import { ProcessLableComponent, getProcess, PROCESS } from 'components/Input/ProcessLableComponent';

import './ConstructionEntryModal.css';
import {
  ClientType,
  ProjectTypes,
  KoujiKbn1,
  KoujiKbn2,
  VisitReason,
  Areas,
  AgeCategories,
} from 'constants/constants';

function ConstructionEntryModal(props) {
  const master = useMaster();
  const restApi = useRestApi();

  // モード情報
  const MODE_LIST = [
    { id: 'add', caption: '登録', variant: 'primary', readOnly: false },
    { id: 'upd', caption: '更新', variant: 'primary', readOnly: false },
    { id: 'del', caption: '削除', variant: 'danger', readOnly: true },
  ];

  // 生年月日を年齢に変換
  const toAgeDisplay = (birthday) => {
    const age = getAge(birthday);
    return age >= 0 ? `${age}歳` : '';
  };

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});

  // 画面モード
  const [mode, setMode] = useState({});

  // 顧客情報
  const [clientInfo, setClientInfo] = useState({});

  // 工事情報
  const [construction, setConstruction] = useState({});

  // 修正前の工事情報
  const [originConstruction, setOriginConstruction] = useState({});

  // ラベル
  const [labels, setLabels] = useState([]);

  // エラーフィールド
  const [errorFileds, setErrorFileds] = useState([]);

  // モーダルの表示
  const [show, setShow] = useState(false);

  // モーダルパラメタの変更処理
  useEffect(() => {
    let construction = props.params.construction;
    if (construction) {
      // エラーをクリア
      setErrorFileds([]);
      // モードを設定
      setMode(MODE_LIST.find((x) => x.id == props.params.mode));

      let clientInfo = props.params.clientInfo;

      // 顧客情報
      setClientInfo(clientInfo);

      // 修正前の工事情報
      setOriginConstruction({ ...construction });

      // 個別の顧客か？
      const isUser = clientInfo.CLIENT_TYPE == ClientType.USER;
      // 工事情報
      if (props.params.mode == 'add') {
        setConstruction({
          ...construction,
          KOUJI_MEI: '',
          IRAI_MEI: '',
          MEETING_SCHEDULED_DATE: null,
          CONSTRUCTION_STATUS: 1,
          LOST_ORDER_DATE: null,
          UKE_DATE: format(new Date(), 'yyyy/MM/dd'),
          UKE_TYPE: '',
          UKE_TYPE_BIKO: '',
          PROJECT_TYPE: '',
          KOUJI_KBN1: '',
          KOUJI_KBN2: '',
          UKE_TAN_CD: '',
          SALES_TAN_CD: '',
          GENBA_TAN_CD: 0,
          BIRTHDAY: clientInfo.BIRTHDAY ? format(new Date(clientInfo.BIRTHDAY), 'yyyy/MM/dd') : '',
          AGE_CATEGORY: clientInfo.BIRTHDAY ? getAgeCategory(clientInfo.BIRTHDAY) : 0,
          VISIT_REASON: 0,
          VISIT_REASON_BIKO: '',
          POST_CODE: isUser ? clientInfo.POST_CODE : '',
          PREF: isUser ? clientInfo.PREF : '',
          CITY: isUser ? clientInfo.CITY : '',
          TOWN: isUser ? clientInfo.TOWN : '',
          AREA: isUser ? clientInfo.AREA : '',
          ADDRESS: isUser ? clientInfo.ADDRESS : '',
          BUILDING: isUser ? clientInfo.BUILDING : '',
          SEIKYU_NAME:
            clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_NAME : clientInfo.NAME_1,
          SEIKYU_POST_CODE:
            clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_POST_CODE : clientInfo.POST_CODE,
          SEIKYU_PREF: clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_PREF : clientInfo.PREF,
          SEIKYU_CITY: clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_CITY : clientInfo.CITY,
          SEIKYU_TOWN: clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_TOWN : clientInfo.TOWN,
          SEIKYU_ADDRESS:
            clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_ADDRESS : clientInfo.ADDRESS,
          SEIKYU_BUILDING:
            clientInfo.INPUT_SEIKYU_FLG == 1 ? clientInfo.SEIKYU_BUILDING : clientInfo.BUILDING,
          DEPARTMENT: '',
          REPRESENTATIVE: '',
          TEL1: clientInfo.TEL1,
          TEL2: clientInfo.TEL2,
        });
      } else {
        setConstruction({
          ...construction,
        });
      }

      // ダイアログを表示
      setShow(true);
    }
  }, [props.params]);

  // 編集処理
  const handleOnChange = (prop) => (target) => {
    let _construction = { ...construction, [prop]: target?.value ?? target?.target.value };

    // 区分③の場合に区分④の範囲外の場合に区分4をクリア
    if (prop == 'KOUJI_KBN1') {
      const k = KoujiKbn2.find((x) => x.key == construction.KOUJI_KBN2);
      if (k) {
        if (!k.KoujiKbn1.includes(parseInt(target?.value))) {
          _construction = { ..._construction, KOUJI_KBN2: '' };
        }
      }
    }
    // 区分①の場合、来店きっかけをクリア
    if (prop === 'PROJECT_TYPE') {
      _construction.VISIT_REASON = 0;
    }
    setConstruction(_construction);
    setErrorFileds([...errorFileds].filter((x) => x != prop));
  };

  // 郵便番号検索
  const searchZip = (prefix) => {
    getAddress(
      master,
      restApi,
      construction[prefix + 'POST_CODE'],
      (json) => {
        let result = json['results'][0];
        setConstruction({
          ...construction,
          [prefix + 'PREF']: result['address1'],
          [prefix + 'CITY']: result['address2'],
          [prefix + 'TOWN']: result['address3'],
        });
        setErrorFileds(
          [...errorFileds].filter(
            (x) => x != prefix + 'PREF' && x != prefix + 'CITY' && x != prefix + 'TOWN'
          )
        );
      },
      setDialog
    );
  };

  // 入力チェック
  const validate = () => {
    let errors = [];
    checkRequired(construction.KOUJI_MEI, '工事名', 'KOUJI_MEI', errors);
    checkRequired(
      construction.CONSTRUCTION_STATUS,
      'ステータス',
      'CONSTRUCTION_STATUS',
      errors,
      true
    );
    if (isEditableLostOrderStatus()) {
      checkRequired(construction.LOST_ORDER_DATE, '失注日', 'LOST_ORDER_DATE', errors);
    }
    checkRequired(construction.UKE_DATE, '見積依頼日', 'UKE_DATE', errors);
    checkRequired(construction.UKE_TYPE, '受付方法', 'UKE_TYPE', errors);
    checkRequired(construction.PROJECT_TYPE, '区分①', 'PROJECT_TYPE', errors);
    checkRequired(construction.KOUJI_KBN1, '区分③', 'KOUJI_KBN1', errors);
    checkRequired(construction.KOUJI_KBN2, '区分④', 'KOUJI_KBN2', errors);
    if (clientInfo.CLIENT_TYPE == ClientType.USER) {
      checkRequired(construction.AGE_CATEGORY, '年代', 'AGE_CATEGORY', errors, true);
    }
    checkRequired(construction.UKE_TAN_CD, '受付担当', 'UKE_TAN_CD', errors);
    checkRequired(construction.SALES_TAN_CD, '営業担当', 'SALES_TAN_CD', errors);
    checkRequired(construction.VISIT_REASON, '来店のきっかけ', 'VISIT_REASON', errors, true);

    checkRequired(construction.POST_CODE, '工事場所 郵便番号', 'POST_CODE', errors);
    checkRequired(construction.PREF, '工事場所 都道府県', 'PREF', errors);
    checkRequired(construction.CITY, '工事場所 市', 'CITY', errors);
    checkRequired(construction.TOWN, '工事場所 町村', 'TOWN', errors);
    checkRequired(construction.AREA, '工事場所 地域', 'AREA', errors, true);
    checkRequired(construction.ADDRESS, '工事場所 番地', 'ADDRESS', errors);

    checkRequired(construction.SEIKYU_NAME, '請求先名', 'SEIKYU_NAME', errors);
    if (clientInfo.CLIENT_TYPE != ClientType.USER) {
      checkRequired(construction.TEL1, '電話番号１', 'TEL1', errors);
    }
    checkRequired(construction.SEIKYU_POST_CODE, '請求先 郵便番号', 'SEIKYU_POST_CODE', errors);
    checkRequired(construction.SEIKYU_PREF, '請求先 都道府県', 'SEIKYU_PREF', errors);
    checkRequired(construction.SEIKYU_CITY, '請求先 市', 'SEIKYU_CITY', errors);
    checkRequired(construction.SEIKYU_TOWN, '請求先 町村', 'SEIKYU_TOWN', errors);
    checkRequired(construction.SEIKYU_ADDRESS, '請求先 番地', 'SEIKYU_ADDRESS', errors);

    setErrorFileds(errors.flatMap((x) => x.fields));

    return errors.map((x) => x.msg);
  };

  const getLostOrderStatusId = () => {
    const status = master.constructionStatus.find((x) => x.name === '失注');
    return status ? status.id : null;
  };
  // 失注ステータスは編集可能
  const isEditableLostOrderStatus = () => {
    const lostOrderId = getLostOrderStatusId();
    if (lostOrderId == null) return false;
    return construction.CONSTRUCTION_STATUS == lostOrderId;
  };

  // 登録ボタン押下処理
  const handleOnClickCreate = () => {
    if (mode.id != 'del') {
      var error = validate();
      if (error.length > 0) {
        setDialog({
          type: 'error',
          message: error,
        });
        return;
      }
    }
    setDialog({
      type: 'confirm',
      message: `${mode.caption}します。よろしいですか？`,
      okCallBack: () => {
        // originConstruction
        let today = new Date();
        let dispDate = master.process.find(
          (p) => p.PROCESS_CD == construction.PROCESS_CD
        )?.DISP_DATE;
        let isChangeProcessCd = originConstruction.PROCESS_CD != construction.PROCESS_CD; // 工程に変更があったか？
        let dashboardDate = !isChangeProcessCd
          ? originConstruction.DASHBOARD_DISP_DATE // 工程が変更なしの場合はそのまま
          : dispDate == 0
          ? '9999-12-31' // 表示期限が無期限の場合
          : format(today.setDate(today.getDate() + dispDate), 'yyyy-MM-dd');

        restApi.post(
          `/api/construction/${mode.id}`,
          {
            ...construction,
            LABELS: labels,
            DASHBOARD_DISP_DATE: dashboardDate,
            IS_CHANGE_PROCESS: isChangeProcessCd,
            LOST_PENDING_DATE: [PROCESS.ON_HOLD, PROCESS.LOST_ORDER].includes(
              construction.PROCESS_CD
            )
              ? construction.LOST_PENDING_DATE
              : null,
          },
          () => {
            let seikyuNo = mode.id == 'upd' ? construction.SEIKYU_NO : -1;
            props.callbak(seikyuNo);
            setShow(false);
          }
        );
      },
    });
  };

  // 閉じるボタン
  const handleClose = useCallback(() => {
    setShow(false);
  }, [props.params]);

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={show}
        disableEnforceFocus={true} // フォーカス制御を無効にする
      >
        <DialogTitle className="p-3">工事情報</DialogTitle>
        <DialogContent className="px-0 py-0 pr-0 pl-0">
          <fieldset disabled={mode?.readOnly}>
            <Card className="m-0">
              <Card.Body>
                <Row>
                  <Col className="pl-3" md="6">
                    <Form.Group>
                      <label>工事名（例：〇〇様　工事名）</label>
                      <br />
                      <TextComponent
                        type="text"
                        placeholder="〇〇様　工事名"
                        value={construction?.KOUJI_MEI}
                        onChange={handleOnChange('KOUJI_MEI')}
                        error={errorFileds.some((x) => x == 'KOUJI_MEI')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pl-3" md="2">
                    <Form.Group>
                      <label>打ち合わせ予定日</label>
                      <br />
                      <TextComponent
                        type="date"
                        value={construction?.MEETING_SCHEDULED_DATE}
                        onChange={handleOnChange('MEETING_SCHEDULED_DATE')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pl-3" md="4">
                    <Form.Group>
                      <label>依頼内容</label>
                      <br />
                      <TextComponent
                        type="text"
                        placeholder="造園工事など"
                        value={construction?.IRAI_MEI}
                        onChange={handleOnChange('IRAI_MEI')}
                        error={errorFileds.some((x) => x == 'IRAI_MEI')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="2">
                    <label>ロボット機(工事種類)</label>
                    <SelectComponent
                      value={construction?.ROBOT_TYPE}
                      onChange={handleOnChange('ROBOT_TYPE')}
                      error={errorFileds.some((x) => x == 'ROBOT_TYPE')}
                    >
                      <option value={'0'}></option>
                      {master.robotTypes.map((x, i) => (
                        <option key={i} value={x['ROBOT_TYPE']}>
                          {x['ROBOT_TYPE_NAME']}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pl-3" md="6">
                    <Form.Group>
                      <label>ロボット機種名</label>
                      <br />
                      <TextComponent
                        type="text"
                        placeholder="ロボット機種名（複数ある場合は、カンマ区切りで入力）"
                        value={construction?.ROBOT_MAKER}
                        onChange={handleOnChange('ROBOT_MAKER')}
                        error={errorFileds.some((x) => x == 'ROBOT_MAKER')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="2">
                    <label>ステータス</label>
                    <SelectComponent
                      value={construction?.CONSTRUCTION_STATUS}
                      onChange={handleOnChange('CONSTRUCTION_STATUS')}
                      error={errorFileds.some((x) => x == 'CONSTRUCTION_STATUS')}
                    >
                      {master.constructionStatus.map((x, i) => (
                        <option key={i} value={x['id']}>
                          {x['name']}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  {isEditableLostOrderStatus() && (
                    <Col className="pl-3" md="2">
                      <Form.Group>
                        <label>失注日</label>
                        <TextComponent
                          type="date"
                          value={construction?.LOST_ORDER_DATE}
                          onChange={handleOnChange('LOST_ORDER_DATE')}
                          error={errorFileds.some((x) => x == 'LOST_ORDER_DATE')}
                        ></TextComponent>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col className="pl-3 pt-3" md="10">
                    <b>＜受付情報＞</b>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="2">
                    <label>見積依頼日</label>
                    <TextComponent
                      type="date"
                      value={construction?.UKE_DATE}
                      onChange={handleOnChange('UKE_DATE')}
                      error={errorFileds.some((x) => x == 'UKE_DATE')}
                    ></TextComponent>
                  </Col>
                  <Col className="pr-1" md="4">
                    <label>受付方法</label>
                    <SelectComponent
                      value={construction?.UKE_TYPE}
                      onChange={handleOnChange('UKE_TYPE')}
                      error={errorFileds.some((x) => x == 'UKE_TYPE')}
                    >
                      <option value={'　'}></option>
                      {master.ukeType.map((x, i) => (
                        <option key={i} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pr-1" md="4">
                    <label>受付方法備考</label>
                    <TextComponent
                      type="text"
                      value={construction?.UKE_TYPE_BIKO}
                      onChange={handleOnChange('UKE_TYPE_BIKO')}
                    ></TextComponent>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="2">
                    <label>区分①</label>
                    <SelectComponent
                      value={construction?.PROJECT_TYPE}
                      onChange={handleOnChange('PROJECT_TYPE')}
                      error={errorFileds.some((x) => x == 'PROJECT_TYPE')}
                    >
                      {ProjectTypes.map((x, i) => (
                        <option key={i} value={x.key}>
                          {x.value}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pr-1" md="2">
                    <Form.Group>
                      <label>区分②</label>
                      <TextComponent
                        value={
                          clientInfo.CLIENT_TYPE == ClientType.USER
                            ? '個人'
                            : clientInfo.CLIENT_TYPE == ClientType.CORP
                            ? '法人'
                            : '公共'
                        }
                        type="text"
                        disabled={true}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="2">
                    <label>区分③</label>
                    <SelectComponent
                      value={construction?.KOUJI_KBN1}
                      onChange={handleOnChange('KOUJI_KBN1')}
                      error={errorFileds.some((x) => x == 'KOUJI_KBN1')}
                    >
                      {KoujiKbn1.map((x, i) => (
                        <option key={i} value={x.key}>
                          {x.value}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pr-1" md="2">
                    <label>区分④</label>
                    <SelectComponent
                      value={construction?.KOUJI_KBN2}
                      onChange={handleOnChange('KOUJI_KBN2')}
                      error={errorFileds.some((x) => x == 'KOUJI_KBN2')}
                    >
                      {KoujiKbn2.filter((x) =>
                        x.KoujiKbn1.includes(parseInt(construction?.KOUJI_KBN1))
                      ).map((x, i) => (
                        <option key={i} value={x.key}>
                          {x.value}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                </Row>
                {clientInfo.CLIENT_TYPE == ClientType.USER && (
                  <Row>
                    <Col className="pr-1" md="2">
                      <label>生年月日</label>
                      <TextComponent
                        type="date"
                        value={construction?.BIRTHDAY}
                        disabled={true}
                      ></TextComponent>
                    </Col>
                    <Col className="pr-1" md="1">
                      <label>年齢(現在)</label>
                      <TextComponent
                        disabled={true}
                        value={toAgeDisplay(construction?.BIRTHDAY)}
                        type="text"
                      ></TextComponent>
                    </Col>
                    <Col className="pr-1" md="2">
                      <label>年代(登録時)</label>
                      <SelectComponent
                        value={construction?.AGE_CATEGORY}
                        onChange={handleOnChange('AGE_CATEGORY')}
                        error={errorFileds.some((x) => x == 'AGE_CATEGORY')}
                      >
                        {AgeCategories.map((x, i) => (
                          <option key={i} value={x.key}>
                            {x.value}
                          </option>
                        ))}
                      </SelectComponent>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col className="pr-1" md="2">
                    <label>受付担当</label>
                    <SelectComponent
                      value={construction?.UKE_TAN_CD}
                      onChange={handleOnChange('UKE_TAN_CD')}
                      error={errorFileds.some((x) => x == 'UKE_TAN_CD')}
                    >
                      <option value={'　'}></option>
                      {master.planer.map((x, i) => (
                        <option key={i} value={x['id']}>
                          {x['name']}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pr-1" md="2">
                    <label>営業担当</label>
                    <SelectComponent
                      value={construction?.SALES_TAN_CD}
                      onChange={handleOnChange('SALES_TAN_CD')}
                      error={errorFileds.some((x) => x == 'SALES_TAN_CD')}
                    >
                      <option value={'　'}></option>
                      {master.salesStaff.map((x, i) => (
                        <option key={i} value={x['id']}>
                          {x['name']}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pr-1" md="2">
                    <label>現場担当</label>
                    <SelectComponent
                      value={construction?.GENBA_TAN_CD}
                      onChange={handleOnChange('GENBA_TAN_CD')}
                    >
                      <option value={0}></option>
                      {master.genbaStaff.map((x, i) => (
                        <option key={i} value={x['id']}>
                          {x['name']}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="4">
                    <label>来店のきっかけ</label>
                    <SelectComponent
                      value={construction?.VISIT_REASON}
                      onChange={handleOnChange('VISIT_REASON')}
                      error={errorFileds.some((x) => x == 'VISIT_REASON')}
                    >
                      <option value={0}></option>
                      {VisitReason.filter(
                        (x) => x.type == parseInt(construction?.PROJECT_TYPE)
                      ).map((x, i) => (
                        <option key={i} value={x.key}>
                          {x.value}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                  <Col className="pr-1" md="4">
                    <label>来店のきっかけ備考</label>
                    <TextComponent
                      type="text"
                      value={construction?.VISIT_REASON_BIKO}
                      onChange={handleOnChange('VISIT_REASON_BIKO')}
                    ></TextComponent>
                  </Col>
                </Row>
                <Row>
                  <Col className="pl-3 pt-3" md="10">
                    <b>＜工事場所＞</b>
                  </Col>
                </Row>
                <Row className="pt-1">
                  <Col className="pr-1" md="3">
                    <div>
                      <label>郵便番号</label>
                    </div>
                    <div className="d-flex">
                      <TextComponent
                        className="post-field mr-2"
                        type="zipcode"
                        value={construction?.POST_CODE}
                        onChange={handleOnChange('POST_CODE')}
                        error={errorFileds.some((x) => x === 'POST_CODE')}
                      />
                      <Button size="sm" variant="default" onClick={() => searchZip('')}>
                        郵便番号検索
                      </Button>
                    </div>
                  </Col>
                  <Col className="pr-1" md="2">
                    <Form.Group>
                      <label>都道府県</label>
                      <TextComponent
                        type="text"
                        value={construction?.PREF}
                        onChange={handleOnChange('PREF')}
                        error={errorFileds.some((x) => x == 'PREF')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="2">
                    <Form.Group>
                      <label>市</label>
                      <TextComponent
                        type="text"
                        value={construction?.CITY}
                        onChange={handleOnChange('CITY')}
                        error={errorFileds.some((x) => x == 'CITY')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="3">
                    <Form.Group>
                      <label>町村</label>
                      <TextComponent
                        type="text"
                        value={construction?.TOWN}
                        onChange={handleOnChange('TOWN')}
                        error={errorFileds.some((x) => x == 'TOWN')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="2">
                    <label>地域</label>
                    <SelectComponent
                      value={construction?.AREA}
                      onChange={handleOnChange('AREA')}
                      error={errorFileds.some((x) => x == 'AREA')}
                    >
                      {Areas.map((x, i) => (
                        <option key={i} value={x.key}>
                          {x.value}
                        </option>
                      ))}
                    </SelectComponent>
                  </Col>
                </Row>
                <Row>
                  <Col className="pr-1" md="5">
                    <Form.Group>
                      <label>番地</label>
                      <TextComponent
                        type="text"
                        value={construction?.ADDRESS}
                        onChange={handleOnChange('ADDRESS')}
                        error={errorFileds.some((x) => x == 'ADDRESS')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="6">
                    <Form.Group>
                      <label>建物名</label>
                      <TextComponent
                        type="text"
                        value={construction?.BUILDING}
                        onChange={handleOnChange('BUILDING')}
                        error={errorFileds.some((x) => x == 'BUILDING')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="pl-3 pt-3" md="10">
                    <b>＜請求先情報＞</b>
                  </Col>
                </Row>
                <Row className="pt-1">
                  <Col className="pr-1" md="5">
                    <Form.Group>
                      <label>請求先名</label>
                      <TextComponent
                        type="text"
                        value={construction?.SEIKYU_NAME}
                        onChange={handleOnChange('SEIKYU_NAME')}
                        error={errorFileds.some((x) => x == 'SEIKYU_NAME')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                </Row>
                {clientInfo.CLIENT_TYPE != ClientType.USER && (
                  <>
                    <Row className="pt-1">
                      <Col className="pr-1" md="3">
                        <Form.Group>
                          <label>部署名</label>
                          <TextComponent
                            type="text"
                            value={construction?.DEPARTMENT}
                            onChange={handleOnChange('DEPARTMENT')}
                          ></TextComponent>
                        </Form.Group>
                      </Col>
                      <Col className="pr-1" md="3">
                        <Form.Group>
                          <label>担当者</label>
                          <TextComponent
                            type="text"
                            value={construction?.REPRESENTATIVE}
                            onChange={handleOnChange('REPRESENTATIVE')}
                          ></TextComponent>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="pt-1">
                      <Col className="pr-1" md="3">
                        <Form.Group>
                          <label>電話番号１</label>
                          <TextComponent
                            type="tel"
                            value={construction?.TEL1}
                            onChange={handleOnChange('TEL1')}
                            error={errorFileds.some((x) => x == 'TEL1')}
                          ></TextComponent>
                        </Form.Group>
                      </Col>
                      <Col className="pr-1" md="3">
                        <Form.Group>
                          <label>電話番号２</label>
                          <TextComponent
                            type="tel"
                            value={construction?.TEL2}
                            onChange={handleOnChange('TEL2')}
                          ></TextComponent>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
                <Row className="pt-1">
                  <Col className="pr-1" md="3">
                    <div>
                      <label>郵便番号</label>
                    </div>
                    <div className="d-flex">
                      <TextComponent
                        className="post-field mr-2"
                        type="zipcode"
                        value={construction?.SEIKYU_POST_CODE}
                        onChange={handleOnChange('SEIKYU_POST_CODE')}
                        error={errorFileds.some((x) => x === 'SEIKYU_POST_CODE')}
                      />
                      <Button size="sm" variant="default" onClick={() => searchZip('SEIKYU_')}>
                        郵便番号検索
                      </Button>
                    </div>
                  </Col>
                  <Col className="pr-1" md="2">
                    <Form.Group>
                      <label>都道府県</label>
                      <TextComponent
                        type="text"
                        value={construction?.SEIKYU_PREF}
                        onChange={handleOnChange('SEIKYU_PREF')}
                        error={errorFileds.some((x) => x == 'SEIKYU_PREF')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="2">
                    <Form.Group>
                      <label>市</label>
                      <TextComponent
                        type="text"
                        value={construction?.SEIKYU_CITY}
                        onChange={handleOnChange('SEIKYU_CITY')}
                        error={errorFileds.some((x) => x == 'SEIKYU_CITY')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="3">
                    <Form.Group>
                      <label>町村</label>
                      <TextComponent
                        type="text"
                        value={construction?.SEIKYU_TOWN}
                        onChange={handleOnChange('SEIKYU_TOWN')}
                        error={errorFileds.some((x) => x == 'SEIKYU_TOWN')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="5">
                    <Form.Group>
                      <label>番地</label>
                      <TextComponent
                        type="text"
                        value={construction?.SEIKYU_ADDRESS}
                        onChange={handleOnChange('SEIKYU_ADDRESS')}
                        error={errorFileds.some((x) => x == 'SEIKYU_ADDRESS')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                  <Col className="pr-1" md="6">
                    <Form.Group>
                      <label>建物名</label>
                      <TextComponent
                        type="text"
                        value={construction?.SEIKYU_BUILDING}
                        onChange={handleOnChange('SEIKYU_BUILDING')}
                        error={errorFileds.some((x) => x == 'SEIKYU_BUILDING')}
                      ></TextComponent>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </fieldset>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={handleClose}>
            閉じる
          </Button>
          <Button
            className="btn-fill footer-button"
            variant={mode?.variant}
            onClick={handleOnClickCreate}
          >
            {mode?.caption}
          </Button>
        </DialogActions>
      </Dialog>
      {/** メッセージモーダル */}
      <MessageModal dialog={dialog}></MessageModal>
    </>
  );
}

export default ConstructionEntryModal;
